















































import {Component, Prop, Vue} from 'vue-property-decorator';
import Loader from "@/components/Loader.vue";
@Component({
  components: { Loader },
})

export default class ContactFormComponent extends Vue {
  @Prop({default: true}) private isLoading!: boolean;
  @Prop({default: false}) private emailSent!: boolean;
  @Prop({default: []}) private errors!: string[];

  @Prop({default: ''}) private name!: string;
  @Prop({default: ''}) private street?: string;
  @Prop({default: ''}) private city?: string;
  @Prop({default: ''}) private country?: string;
  @Prop({default: ''}) private postcode?: string;
  @Prop({default: ''}) private telephone?: string;
  @Prop({default: ''}) private email!: string;
  @Prop({default: ''}) private remark!: string;

  @Prop({ required: true }) readonly formHandleEndpoint!: string;
  @Prop({ required: true }) readonly redirectUrl!: string;

  private async handleClick(e: Event) {
    e.preventDefault();

    this.validateForm();
    if (this.errors.length > 0) return;

    const payload = {
      name: this.name,
      street: this.street || "",
      postcode: this.postcode || "",
      city: this.city || "",
      country: this.country || "",
      telephone: this.telephone || "",
      email: this.email,
      remark: this.remark
    };

    try {
      const resp = await fetch(this.formHandleEndpoint, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload),
      });

      if (!resp.ok) {
        // try to read error details but fall back to a generic message
        let detail = "";
        try { detail = await resp.text(); } catch {}
        throw new Error(`Submit failed (${resp.status}) ${detail}`);
      }

      this.emailSent = true; // keeping your existing pattern
      window.location.assign(this.redirectUrl);
    } catch (err) {
      console.error(err);
      this.errors.push(String(this.$t("email.error")));
    }
  }

  private clearForm() {
    this.name = '';
    this.street = '';
    this.postcode = '';
    this.city = '';
    this.country = '';
    this.telephone = '';
    this.email = '';
    this.remark = '';
  }

  private validateEmail(): boolean{
    let reg = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return reg.test(this.email);
  }

  private validateForm() {
    this.errors = [];
    let errMsg = "";
    if(!this.name) {
      errMsg = this.$t('email.error.name') as string;
      this.errors.push(errMsg);
    };
    if(!this.email) {
      errMsg = this.$t('email.error.email') as string;
      this.errors.push(errMsg);
    } else if (!this.validateEmail()) {
      errMsg = this.$t('email.error.validEmail') as string;
      this.errors.push(errMsg);
    }
    if(!this.remark) {
      errMsg = this.$t('email.error.remark') as string;
      this.errors.push(errMsg);
    }

  }

  mounted() {
    this.isLoading = false;
  }
}
